//GeoFence.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GetSales from "./GetSales";
import * as GraLay from "../Util/GraLay";
import * as MainMap from "../MainMap";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Settings from "../Settings";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Util_MUI from "../Util/Util_MUI";

import { Button, ButtonGroup, Checkbox, FormControlLabel, Icon, IconButton, TextField, Typography } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

//ESRI javascript API.
import Graphic from "@arcgis/core/Graphic";
import Query from "@arcgis/core/rest/support/Query";
import * as QueryTask from "@arcgis/core/rest/query";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

import React from "react";

export let geoFenceGeom: __esri.Geometry = null;
export let subjectGeofenceMode: string = "Neighborhood"; //"Neighborhood" or "Circle"
export let prevSearchRadius: number = 0;

let ss: SalesSearchSettings.iSS; //Settings.
let currentMapView: boolean = false;

let sketchVM: __esri.SketchViewModel; // API sketch view model.

let neighborhoodMode: boolean = false;
let neighborhoodBackColor: ButtonProps["color"] = "primary";

let drawPolyMode: boolean = false;
let drawPolyBackColor: ButtonProps["color"] = "primary";

let searchRadiusText: string = "Any";
let searchRadius: number = 0;

let prevCenX: number = 0;

//Perform spatial query for neighborhood polygon geometry.
export function getNeighborhoodGeom(pnt: __esri.Point) {
   subjectGeofenceMode = "Neighborhood";

   const laySpec: Settings.iLayer = Util_App.getLayerSpec(ss.neighborhood_layerName);
   if (!laySpec) {
      Util.errMsg("Neighborhood layer not found: " + ss.neighborhood_layerName);
      return;
   }

   const query = new Query({
      returnGeometry: true,
      outSpatialReference: MainMap.activeView.spatialReference,
      geometry: pnt,
      geometryPrecision: 0,
      maxAllowableOffset: Util_App.feetToMeters(Settings.maxAllowableOffset),
      outFields: ["OBJECTID"],
   });

   //Execute spatial query.
   const url: string = Util_App.getLayerURL(laySpec);
   QueryTask.executeQueryJSON(url, query).then(getNeighborhood_success).catch(queryTask_failed);
}

function getNeighborhood_success(fs: __esri.FeatureSet): void {
   if (fs.features.length > 0) {
      geoFenceGeom = fs.features[0].geometry;
      const gra = new Graphic({ geometry: geoFenceGeom, symbol: ss.geomSym });
      GraLay.appPoly.removeAll();
      GraLay.appPoly.add(gra);
      //const mbr = Util_App.addMarginToMBR(geom.extent, true);
      MainMap.activeView.goTo(geoFenceGeom.extent, Settings.animateOptions);
      SalesSearch.autoSearch();

   } else {
      SnackBar.show("Neighborhood not found", 2);
   }

}

//Query task failed.
function queryTask_failed(error: Error): void {
   Util.errMsg("QueryTask failed", error);
}

//Create circular buffer with geometry engine.
export function createCircle(cenPnt: __esri.Point, radius?: number) {
   subjectGeofenceMode = "Circle";

   //Set search radius.
   if (radius) {
      searchRadiusText = radius.toString();
      searchRadius = radius;
   }

   //Create circular buffer with geometry engine.
   let polys: __esri.Polygon | __esri.Polygon[];

   if (MainMap.activeView.spatialReference.isWebMercator) {
      polys = Util_App.geometryEngine.geodesicBuffer(cenPnt, searchRadius, "miles");
   } else {
      polys = Util_App.geometryEngine.buffer(cenPnt, searchRadius, "miles");
   }

   geoFenceGeom = polys as __esri.Geometry;

   const gra = new Graphic({ geometry: geoFenceGeom, symbol: ss.geomSym });
   GraLay.appPoly.removeAll();
   GraLay.appPoly.add(gra);

   if (SalesSearch.activePIN) {
      SalesSearch.autoSearch();

   } else { //No active pin.
      if (DrawerMenu.curToolName === "Sales Search") {
         SalesSearch.autoSearch();
      } else {
         GetSales.search();
      }
   }
}

//Create rectangle.
export function createRectangle() {
   geoFenceGeom = MainMap.activeView.extent;
   const gra = new Graphic({ geometry: geoFenceGeom, symbol: ss.geomSym });
   GraLay.appPoly.removeAll();
   GraLay.appPoly.add(gra);
}

//Clear geometry tools.
export function clearNeighborhood(clearGeom?: boolean) {
   neighborhoodMode = false;
   neighborhoodBackColor = "primary";
   if (clearGeom) {
      clearGeoFenceGeom();
   }
   MainMap.activeViewDiv.style.cursor = "default";
}

export function clearDrawPoly(clearGeom?: boolean) {
   drawPolyMode = false;
   drawPolyBackColor = "primary";
   if (clearGeom) {
      clearGeoFenceGeom();
   }
   if (sketchVM) {
      sketchVM.cancel();
   }
   MainMap.activeViewDiv.style.cursor = "default";
}

export function clearSearchRadius(clearGeom?: boolean) {
   searchRadiusText = "Any";
   searchRadius = 0;

   if (clearGeom) {
      clearGeoFenceGeom();
   }
}

function clearGeoFenceGeom() {
   GraLay.appPoly.removeAll();
   geoFenceGeom = null;
}

//Clear all geofences.
export function clearGeoFences() {
   clearNeighborhood();
   clearDrawPoly();
   clearSearchRadius(true);
   currentMapView = false;
}

//Clear this tool.
export function clearTool() {
   neighborhoodMode = false;
   neighborhoodBackColor = "primary";

   drawPolyMode = false;
   drawPolyBackColor = "primary";

   if (DrawerMenu.curToolName === "Sales Search" && SalesSearch.layer.totRec === 0) {
      GraLay.appPoly.removeAll();
   }

   if (sketchVM) {
      sketchVM.cancel();
   }
   MainMap.activeViewDiv.style.cursor = "default";
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of GeoFence.Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = SalesSearchSettings.ss; //Get settings.
   }

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {

      //Select a neighborhood polygon.
      MainMap.activeView.on("click", function (event) {
         if (neighborhoodMode) {
            getNeighborhoodGeom(event.mapPoint);
         }
      });

      //Search for sales points when panning when no subject parcel.
      reactiveUtils.when(() => MainMap.activeView?.stationary === true, function () {
         if (DrawerMenu.curToolName === "Sales Search" || DrawerMenu.curToolName === "Sales Results") {

            if (!SalesSearch.activePIN) {
               const x: number = Util.round(MainMap.activeView.extent.center.x);
               if (x !== prevCenX && prevCenX !== 0) {

                  if (currentMapView) {
                     createRectangle();

                     if (DrawerMenu.curToolName === "Sales Results") {
                        GetSales.search();
                     }

                  } else if (searchRadiusText !== "Any") {
                     createCircle(MainMap.activeView.center);
                  }
               }

               prevCenX = x;
            }
         }
      });
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Select a neighborhood button click.
   function neighborhoodButtonClick() {
      clearDrawPoly();
      clearSearchRadius();
      currentMapView = false;

      if (neighborhoodMode) {
         clearNeighborhood();

      } else {
         neighborhoodMode = true;
         neighborhoodBackColor = "secondary";
         clearGeoFenceGeom();
         MainMap.activeViewDiv.style.cursor = "pointer";
      }
      refresh();
   }

   //Draw polygon on map button click.
   function drawPolyButtonClick() {
      //Load the sketch view model module.
      import("@arcgis/core/widgets/Sketch/SketchViewModel").then(({ default: SketchViewModel }) => {

         subjectGeofenceMode = "Neighborhood";

         clearNeighborhood();
         clearSearchRadius();
         currentMapView = false;

         if (drawPolyMode) {
            clearDrawPoly();

         } else {
            drawPolyMode = true;
            drawPolyBackColor = "secondary";
            clearGeoFenceGeom();

            //Create the sketch view model.
            if (!sketchVM) {
               sketchVM = new SketchViewModel({
                  layer: GraLay.appPoly,
                  view: MainMap.activeView,
                  polygonSymbol: ss.geomSym,
                  updateOnGraphicClick: true,
                  defaultUpdateOptions: { tool: "reshape", toggleToolOnClick: false, enableRotation: false, enableScaling: true },
               });
            }

            //Fire up the drawing tool.
            GraLay.appPoly.removeAll();
            sketchVM.create("polygon");

            //Draw polygon complete.
            sketchVM.on("create", function (event) {
               if (event.state === "complete") {
                  geoFenceGeom = event.graphic.geometry;
                  const mbr = Util_App.addMarginToMBR(geoFenceGeom.extent, true);
                  setTimeout(function () { MainMap.activeView.goTo(mbr, Settings.animateOptions); }, 100);

                  drawPolyMode = false;
                  drawPolyBackColor = "primary";
                  SalesSearch.autoSearch();
                  refresh();
               }
            }); //end sketch view model on create event.

         }
         refresh();

      }).catch((error: Error) => {
         console.error('An error occurred while loading the Sketch View Model module:', error);
      });
   }

   //Search radius changed.
   function searchRadiusChanged(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      searchRadiusText = event.target.value;
      searchRadius = Util.parseFlt(searchRadiusText);
      clearNeighborhood();
      clearDrawPoly(true);
      currentMapView = false;

      //Create circular buffer with geometry engine.
      if (searchRadiusText !== "Any") {
         let cenPnt = MainMap.activeView.center;
         if (SalesSearch.activePIN) {
            cenPnt = ss.subjectCentroid;
         }
         createCircle(cenPnt);
         MainMap.activeView.goTo(geoFenceGeom.extent, Settings.animateOptions);
         prevSearchRadius = searchRadius;

      } else {
         subjectGeofenceMode = "Neighborhood";
      }
      refresh();
   }

   //Current map view checkbox click event.
   function currentMapViewChanged(event: React.ChangeEvent<HTMLInputElement>) {
      currentMapView = event.target.checked;

      if (currentMapView) {
         subjectGeofenceMode = "Neighborhood";
         clearNeighborhood();
         clearDrawPoly();
         clearSearchRadius(true);
         createRectangle();
         SalesSearch.autoSearch();
      }
      refresh();
   }

   //Clear all geofences.
   function clearAllGeoFences() {
      clearGeoFences();
      refresh();
   }

   //Set render values.
   const ti_region: Settings.iToolInfo = Settings.getToolInfo("Region");
   const ti_poly: Settings.iToolInfo = Settings.getToolInfo("Polygon");

   const regionIcon = <Icon color='action'>{ti_region.iconName}</Icon>;
   const polyIcon = <Icon color='action'>{ti_poly.iconName}</Icon>;

   let neighborhoodVisible: boolean = true;
   if (Settings.security.accessLevel < ss.accessLevel_neighborhood) {
      neighborhoodVisible = false;
   }

   const styles: Default.iStyles = {
      col1Container: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'stretch', marginBottom: 2 },
      clearButton: { marginLeft: -22, marginTop: 15, border: '1px solid silver' },
   };

   return (
      <div style={styles.col1Container}>

         <Typography variant="body2" style={{ marginTop: 2, marginBottom: 8 }}>
            Filter by neighborhood, polygon, or circular radius
         </Typography>

         <div className="app-flex-row-around">

            <div style={styles.col1Container}>
               <ButtonGroup variant="contained" fullWidth aria-label="Geometry filters">
                  {neighborhoodVisible &&
                     <Button startIcon={regionIcon} color={neighborhoodBackColor} onClick={neighborhoodButtonClick} title="Click a neighborhood on the map to filter search results" aria-label="Neighborhood">
                        Neighborhood
                     </Button>}

                  <Button startIcon={polyIcon} color={drawPolyBackColor} onClick={drawPolyButtonClick} title="Draw a polygon on the map to filter search results.  Double-click to finish" aria-label="Draw Area">
                     Draw Area
                  </Button>
               </ButtonGroup>

               <div className="app-flex-row-around" style={{ marginLeft: 5, marginTop: 18 }}>
                  <Typography variant="body1">
                     Radius(mi):
                  </Typography>

                  <TextField select style={{ width: 122, marginLeft: 8, marginRight: 15 }}
                     label="Search Radius"
                     title="Choose search radius to filter search results"
                     slotProps={{
                        htmlInput: { id: "search-radius" },
                        inputLabel: { htmlFor: "search-radius" }
                     }}
                     value={searchRadiusText}
                     onChange={searchRadiusChanged}
                  >
                     {Util_MUI.buildSelectMenuItems(ss.searchRadius_list)}
                  </TextField>

                  <FormControlLabel title="Filter search results by current map extent"
                     control={<Checkbox inputProps={{ id: "geofence-extent" }} checked={currentMapView} color="primary" onChange={currentMapViewChanged} />}
                     label="Map view"
                  />
               </div>
            </div>

            <IconButton style={styles.clearButton} color="primary" size="small" onClick={clearAllGeoFences} title="Clear all geometry search results filters" aria-label="clear-geom-menu">
               <Icon fontSize="small">clear</Icon>
            </IconButton>
         </div>

      </div>
   ); //end return.

} //end function.
